
export default function Label({ htmlFor, children }) {
  return (
      <label htmlFor={htmlFor} className="block text-sm mb-2 dark:text-white">
        {children}
      </label>
  )
}